/* NOONCUP coffee finder. Port of the Primal Wine club wizard's step model:
   numbered stepper, option cards that auto-advance, recap panel, Back.
   Ranks the in-stock coffees by the facts each roaster states. */
(() => {
  const root = document.querySelector('[data-finder]');
  if (!root) return;
  const DATA = JSON.parse(document.querySelector('[data-finder-data]').textContent)
    .filter(x => x.a && x.d.k !== 'chocolate');
  const $steps = root.querySelector('[data-steps]');
  const $pane = root.querySelector('[data-pane]');
  const $recap = root.querySelector('[data-recap]');
  const check = '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  const esc = (s) => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  const STEPS = [
    { key: 'brew', label: 'Brew', q: 'How do you make coffee?', opts: [
      ['espresso', 'Espresso machine', 'Shots, lattes, cappuccinos'],
      ['filter', 'Pour over or drip', 'V60, Chemex, Kalita, a drip machine'],
      ['press', 'French press', 'Full immersion, coarse grind'],
      ['cold', 'Cold brew', 'Steeped cold for 12 to 24 hours'],
      ['moka', 'Moka pot', 'Stovetop, strong and short'],
      ['any', 'A bit of everything', 'No single method'] ] },
    { key: 'roast', label: 'Roast', q: 'Which roast do you like?', opts: [
      ['light', 'Light', 'Roasted shortest. Brighter, more acidity'],
      ['medium', 'Medium', 'Between light and dark'],
      ['dark', 'Dark', 'Roasted longest. Roasty, less acidity'],
      ['any', 'Not sure', 'Rank every roast the same'] ] },
    { key: 'flavor', label: 'Flavor', q: 'Pick up to 2 flavors', multi: 2, opts: [
      ['fruity', 'Fruity', 'Citrus, stone fruit, berries'],
      ['chocolate', 'Chocolate and caramel', 'Cocoa, toffee, brown sugar'],
      ['nutty', 'Nutty', 'Almond, hazelnut, peanut'],
      ['floral', 'Floral', 'Jasmine, bergamot, blossom'],
      ['smoky', 'Smoky and spiced', 'Smoke, cedar, tobacco'] ] },
    { key: 'caf', label: 'Caffeine', q: 'Caffeine or decaf?', opts: [
      ['regular', 'Caffeinated', 'The regular bag'],
      ['decaf', 'Decaf', 'Decaffeinated coffees only'] ] },
  ];
  const RESULT = STEPS.length;
  const state = { step: 0, brew: null, roast: null, flavor: [], caf: null, dir: 1 };
  const R = { light: 1, 'medium-light': 1.5, medium: 2, 'medium-dark': 2.5, dark: 3 };
  const ROAST_NAME = { light: 'Light roast', 'medium-light': 'Medium-light roast', medium: 'Medium roast', 'medium-dark': 'Medium-dark roast', dark: 'Dark roast' };
  const FLAV = { fruity: 'Fruity notes', chocolate: 'Chocolate notes', nutty: 'Nutty notes', floral: 'Floral notes', smoky: 'Smoky notes' };

  function label(stepKey, val) {
    const s = STEPS.find(x => x.key === stepKey);
    if (Array.isArray(val)) return val.length ? val.map(v => s.opts.find(o => o[0] === v)[1]).join(', ') : '';
    const o = s.opts.find(o => o[0] === val); return o ? o[1] : '';
  }

  function rank() {
    const want = R[state.roast];
    return DATA.filter(x => state.caf === 'decaf' ? x.d.dc : !x.d.dc)
      .map(x => {
        let s = 0; const why = [];
        if (want && R[x.d.ro]) { const d = Math.abs(R[x.d.ro] - want); s += 3 - 2 * d; if (d <= .5) why.push(ROAST_NAME[x.d.ro]); }
        else if (want) s += .5;
        for (const f of state.flavor) if (x.d.fl.includes(f)) { s += 2; why.push(FLAV[f]); }
        if (state.brew === 'espresso' && x.d.k === 'espresso') { s += 2; why.push('Espresso blend'); }
        if (state.brew !== 'espresso' && x.d.k === 'espresso') s -= .5;
        if (state.brew === 'filter' && x.d.k === 'pour-over') { s += 1; why.push('Pour-over bags'); }
        if (x.d.k === 'instant') s -= 2;
        if (state.caf === 'decaf') why.push('Decaf');
        if (x.d.nt.length) s += .25;
        return { x, s, why };
      })
      .sort((a, b) => b.s - a.s || a.x.pc - b.x.pc)
      .slice(0, 6);
  }

  function renderSteps() {
    const all = [...STEPS.map(s => s.label), 'Results'];
    $steps.innerHTML = all.map((l, i) => {
      const cls = i < state.step ? 'is-done' : i === state.step ? 'is-on' : '';
      const num = i < state.step ? check : i + 1;
      return `<li class="fz__step ${cls}"${i === state.step ? ' aria-current="step"' : ''}><span class="fz__num">${num}</span><span class="fz__label">${l}</span></li>`;
    }).join('');
  }

  function renderRecap() {
    if (!$recap) return;
    $recap.innerHTML = STEPS.map(s => `<div class="recap-row"><span>${s.label}</span><b>${esc(label(s.key, state[s.key]) || '-')}</b></div>`).join('')
      + `<p class="note" style="margin-top:10px">${DATA.length} coffees in stock to rank.</p>`;
  }

  function renderPane() {
    $pane.classList.remove('fz__pane', 'is-back'); void $pane.offsetWidth;
    $pane.classList.add('fz__pane'); if (state.dir < 0) $pane.classList.add('is-back');
    if (state.step === RESULT) return renderResults();
    const s = STEPS[state.step];
    const sel = state[s.key];
    $pane.innerHTML = `
      <h2 class="fz__q" tabindex="-1">${s.q}</h2>
      ${s.multi ? `<p class="fz__hint">${sel.length} of ${s.multi} picked</p>` : ''}
      <div class="fz__opts" role="${s.multi ? 'group' : 'radiogroup'}" aria-label="${esc(s.q)}">
        ${s.opts.map(([v, t, sub]) => {
          const on = s.multi ? sel.includes(v) : sel === v;
          return `<button type="button" class="opt" role="${s.multi ? 'checkbox' : 'radio'}" aria-checked="${on}" data-v="${v}"><b>${t}</b><span>${sub}</span><i class="opt__tick">${check}</i></button>`;
        }).join('')}
      </div>
      <div class="fz__nav">
        ${state.step > 0 ? `<button class="btn btn--cream" type="button" data-back>Back</button>` : ''}
        ${s.multi ? `<button class="btn" type="button" data-next ${sel.length ? '' : 'disabled'}>Continue</button>` : ''}
      </div>`;
    $pane.querySelector('.fz__q').focus({ preventScroll: true });
  }

  function renderResults() {
    const list = rank();
    const sum = [label('brew', state.brew), label('roast', state.roast), label('flavor', state.flavor), label('caf', state.caf)].filter(Boolean).join(' / ');
    $pane.innerHTML = `
      <h2 class="fz__q" tabindex="-1">Your top ${list.length}</h2>
      <p class="fz__hint">${esc(sum)}</p>
      <div style="display:grid;gap:10px">
        ${list.map(({ x, why }, i) => `
          <article class="res" style="animation-delay:${i * 50}ms">
            <a class="res__img" href="${x.u}" tabindex="-1" aria-hidden="true"><img src="${x.i}" alt="" loading="lazy" width="92" height="92"></a>
            <div style="min-width:0">
              <span class="res__rank">No. ${i + 1}</span>
              <span class="mono muted" style="display:block">${esc(x.d.r)}</span>
              <a class="res__t" href="${x.u}">${esc(x.d.n)}</a>
              ${why.length ? `<div class="res__why">${why.map(w => `<span class="badge">${esc(w)}</span>`).join('')}</div>` : (x.d.nt.length ? `<p class="note">${esc(x.d.nt.join(', '))}</p>` : '')}
              <div class="res__row"><span class="price">${x.p}</span><button class="btn btn--sm" type="button" data-add="${x.v}" data-title="${esc(x.d.n)}">Add to bag</button></div>
            </div>
          </article>`).join('')}
      </div>
      <div class="fz__nav" style="margin-top:14px">
        <button class="btn btn--cream" type="button" data-restart>Start over</button>
        <a class="btn btn--cream" href="/collections/specialty-coffee">Browse all</a>
      </div>`;
    $pane.querySelector('.fz__q').focus({ preventScroll: true });
  }

  // the Back/Continue bar is position: fixed; keep it lined up with the question column and only show it while the finder is on screen
  let fzOnScreen = true;
  const placeNav = () => {
    const nav = $pane.querySelector('.fz__nav'); if (!nav) return;
    const r = $pane.getBoundingClientRect();
    nav.style.setProperty('--fz-l', r.left + 'px'); nav.style.setProperty('--fz-w', r.width + 'px');
    nav.classList.toggle('is-off', !fzOnScreen);
  };
  new IntersectionObserver(([en]) => { fzOnScreen = en.isIntersecting; placeNav(); }, { rootMargin: '0px 0px -120px 0px' }).observe(root);
  addEventListener('resize', placeNav);

  function render() { renderSteps(); renderRecap(); renderPane(); placeNav(); }
  function go(n) {
    state.dir = n > state.step ? 1 : -1; state.step = n; render();
    const top = root.getBoundingClientRect().top + scrollY - 80;
    if (scrollY > top) scrollTo({ top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }

  $pane.addEventListener('click', (e) => {
    const o = e.target.closest('.opt');
    if (o) {
      const s = STEPS[state.step]; const v = o.dataset.v;
      if (s.multi) {
        const arr = state[s.key]; const i = arr.indexOf(v);
        if (i >= 0) arr.splice(i, 1); else { if (arr.length >= s.multi) arr.shift(); arr.push(v); }
        $pane.querySelectorAll('.opt').forEach(b => b.setAttribute('aria-checked', arr.includes(b.dataset.v)));
        $pane.querySelector('.fz__hint').textContent = `${arr.length} of ${s.multi} picked`;
        $pane.querySelector('[data-next]').disabled = !arr.length;
        renderRecap();
      } else {
        state[s.key] = v;
        $pane.querySelectorAll('.opt').forEach(b => b.setAttribute('aria-checked', b === o));
        renderRecap();
        setTimeout(() => go(state.step + 1), 220);
      }
      return;
    }
    if (e.target.closest('[data-next]')) go(state.step + 1);
    else if (e.target.closest('[data-back]')) go(state.step - 1);
    else if (e.target.closest('[data-restart]')) { Object.assign(state, { brew: null, roast: null, flavor: [], caf: null }); go(0); }
  });
  $steps.addEventListener('click', (e) => {
    const li = e.target.closest('.fz__step'); if (!li) return;
    const i = [...$steps.children].indexOf(li); if (i < state.step) go(i);
  });
  render();
})();
